// @generated by protobuf-ts 2.9.6 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/enums/moderation/moderation_item_type.proto" (package "bianka.enums.moderation", syntax proto3)
// tslint:disable
/**
 * Moderation entities types that are supported by unified moderation service
 *
 * @generated from protobuf enum bianka.enums.moderation.ModerationItemType
 */
export enum ModerationItemType {
    /**
     * @generated from protobuf enum value: MODERATION_ITEM_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: MODERATION_ITEM_TYPE_BRIEF = 1;
     */
    BRIEF = 1,
    /**
     * @generated from protobuf enum value: MODERATION_ITEM_TYPE_ORDER = 2;
     */
    ORDER = 2,
    /**
     * @generated from protobuf enum value: MODERATION_ITEM_TYPE_USER = 3;
     */
    USER = 3,
    /**
     * @generated from protobuf enum value: MODERATION_ITEM_TYPE_GIG = 4;
     */
    GIG = 4,
    /**
     * @generated from protobuf enum value: MODERATION_ITEM_TYPE_MESSAGE = 5;
     */
    MESSAGE = 5,
    /**
     * @generated from protobuf enum value: MODERATION_ITEM_TYPE_VIDEO_CALL = 6;
     */
    VIDEO_CALL = 6,
    /**
     * @generated from protobuf enum value: MODERATION_ITEM_TYPE_SELLER_ROLE = 7;
     */
    SELLER_ROLE = 7,
    /**
     * @generated from protobuf enum value: MODERATION_ITEM_TYPE_PORTFOLIO_PROJECT = 8;
     */
    PORTFOLIO_PROJECT = 8
}
